$(function() {
    let $loadBrokersContent = $('#loadBrokersContent');

    if(localStorage.getItem('preloader') === 'true') {
        let params = (new URL(document.location)).searchParams;
        let code = params.get('code');
        window.post_code = params.get('post_code');
        if($('#loadBrokersContent').length && window.post_code !== '' && code === null) {
            $('.body-wrap').addClass('blur');
            $('#preloaderModal').modal('show');
            getBrokers();
        }
    } else {
        let params = (new URL(document.location)).searchParams;
        window.post_code = params.get('post_code');
        if(window.post_code !== null && window.post_code !== ""){
            getBrokers();
        }
    }

    function getBrokers() {
        $.ajax({
            url: window.ajax_url,
            data: {
                'action': 'get_brokers',
                'data': {
                    post_code: window.post_code,
                },
            },
            type: 'POST',
        }).done(function (res) {
            let response = JSON.parse(res);
            window.offset = parseInt(response.offset);
            $('#countBroker').text(response.found_posts);
            $('#postCodeResult').text(window.post_code);
            if (response.html !== '') {
                startPreloader($('.processing-text'), $('.lds-spinner'), $('.processing-text').attr('data-interval'), window.post_code);
                $loadBrokersContent.html(response.html);
                $loadBrokersContent.find('.broker-card').fadeIn(300);
            } else {
                setTimeout(function () {
                    $('#preloaderModal').modal('hide');
                    $loadBrokersContent.find('.lds-spinner').addClass('d-none');
                    $('#preloaderNoBrokerModal').modal('show');
                }, 300);
            }
            if(response.found_posts === $loadBrokersContent.children('.broker-card').length) {
                $('#showMoreBrokers').remove();
            }
        }).fail(function () {
            alert('Error query');
        });
    }

    function startPreloader(text_element, preloader_element, interval) {
        let i = 0;
        let count = text_element.children('div').length;
        let timerId = setInterval(function() {
            if(i < (count - 1)) {
                i = i + 1;
                text_element.children('div').addClass('d-none');
                text_element.children('div:eq('+i+')').removeClass('d-none');
                if(i === (count - 1)) {
                    preloader_element.addClass('d-none');
                }
            } else {
                clearInterval(timerId);
            }
        }, interval);
    }

    $('#showMoreBrokers').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        let params = (new URL(document.location)).searchParams;
        window.post_code = (params.get('post_code') !== null) ? params.get('post_code') : window.post_code;
        if(params.get('code') !== null) {
            $this.find('.cont').children('.lds-ring').removeClass('d-none');
            $.ajax({
                url: window.ajax_url,
                data: {
                    'action': 'get_brokers_by_code',
                    'data': {
                        code: params.get('code'),
                        post_code: window.post_code,
                        offset: window.offset,
                    },
                },
                type: 'POST',
            }).done(function (res) {
                let response = JSON.parse(res);
                window.offset = parseInt(response.offset);
                if (response.html !== '') {
                    $this.find('.cont').children('.lds-ring').addClass('d-none');
                    $loadBrokersContent.append(response.html);
                    $loadBrokersContent.find('.broker-card').fadeIn(300);
                }
                if(response.found_posts === $loadBrokersContent.children('.broker-card').length) {
                    $this.remove();
                }
            }).fail(function () {
                alert('Error query');
            });
        } else {
            if($loadBrokersContent.length && window.post_code !== '') {
                $this.find('.cont').children('.lds-ring').removeClass('d-none');
                $.ajax({
                    url: window.ajax_url,
                    data: {
                        'action': 'get_brokers',
                        'data': {
                            post_code: window.post_code,
                            offset: window.offset,
                        },
                    },
                    type: 'POST',
                }).done(function (res) {
                    let response = JSON.parse(res);
                    window.offset = parseInt(response.offset);
                    if (response.html !== '') {
                        $this.find('.cont').children('.lds-ring').addClass('d-none');
                        $loadBrokersContent.append(response.html);
                        $loadBrokersContent.find('.broker-card').fadeIn(300);
                    }
                    if(response.found_posts === $loadBrokersContent.children('.broker-card').length) {
                        $this.remove();
                    }
                }).fail(function () {
                    alert('Error query');
                });
            }
        }
    });

    $('#nextPreloaderButton').on('click', function (e) {
        e.preventDefault();
        $('#preloaderModal').modal('hide');
        $('#userDetailsFormModal').modal('show');
        $('.body-wrap').addClass('blur');
    });

    $('#userDetailsFormModal').on('hide.bs.modal', function () {
        $('.body-wrap').removeClass('blur');
    });
});


// WEBPACK FOOTER //
// ./scripts/routes/preloader-modal.js